import { render } from "./NewPassword.vue?vue&type=template&id=34bbd54c&ts=true"
import script from "./NewPassword.vue?vue&type=script&lang=ts"
export * from "./NewPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/ev-connect-dashboard/ev-connect-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__